module.exports = "<p>\n  cameras-publicas works!\n</p>\n"